import mock from 'api/mockFastApi';

mock.onPost('resources/opinion/update-opinion').reply(() => {
    return [200, 'ok'];
});
